<scitis-app-global-page-header [pageTitle]="'Users'">
</scitis-app-global-page-header>

<div class="card mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th scope="col" class="sortable" style="width: 140px;" sortable="agreementAccepted" (sort)="onColumnSort($event)"><span translate>Agreement</span>
          </th>
          <th scope="col" class="sortable" sortable="displayName" (sort)="onColumnSort($event)"><span translate>Display name</span>
        </th>
        <th scope="col" class="sortable" sortable="username" (sort)="onColumnSort($event)"><span translate>Name</span>
      </th>
    </tr>
  </thead>
  <tbody>
    @for (user of users; track user) {
      <tr>
        <td>
            <span class="badge" [ngClass]="{
            			    		'badge-success': user.agreementAccepted,
            			    		'badge-danger' : !user.agreementAccepted

			    	}">
            @if (user.agreementAccepted) {
              <span>{{ 'Accepted' | translate }}</span>
            }
            @if (!user.agreementAccepted) {
              <span>{{ 'Not accepted' | translate }}</span>
            }
          </span>
        </td>
        <td>
          @if (user.banned) {
            <del title="{{'User banned.' | translate}}"><strong [innerText]="user.displayName"></strong></del>
          }
          @if (!user.banned) {
            <span> <strong [innerText]="user.displayName"></strong></span>
          }
        </td>
        <td [innerText]="user.username"></td>
      </tr>
    }
  </tbody>
</table>
</div>
</div>
</div>

<scitis-page-summary [itemsCount]="users.length"
  [singleItemText]="translate.instant('User')"
  [multipleItemsText]="translate.instant('Users')">

</scitis-page-summary>
